import(/* webpackMode: "eager" */ "/var/www/boltfreight/src/app/not-found.tsx");
